import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export const create = async (data: {
  buyerBusinessId: string;
  /** `YYYY-MM` (UB). Хуулга нь нэг бүтэн сар. */
  month: string;
  currency: string;
  sellerNotes?: string;
}) => httpRequest.post("/inv/reconciliation-statements", data);

export const send = async (id: string, data?: { sellerNotes?: string }) =>
  httpRequest.post(`/inv/reconciliation-statements/${id}/send`, data);

export const revise = async (id: string, data?: { sellerNotes?: string }) =>
  httpRequest.post(`/inv/reconciliation-statements/${id}/revise`, data);

export const approve = async (id: string, data?: { buyerNotes?: string; buyerSignature?: string }) =>
  httpRequest.post(`/inv/reconciliation-statements/${id}/approve`, data);

export const reject = async (id: string, data: { rejectionReason: string }) =>
  httpRequest.post(`/inv/reconciliation-statements/${id}/reject`, data);

export const list = async (params?: any) =>
  httpRequest.get("/inv/reconciliation-statements", params);

export const get = async (id: string) =>
  httpRequest.get(`/inv/reconciliation-statements/${id}`);

export const pdf = async (id: string): Promise<string> =>
  httpRequest.get(`/inv/reconciliation-statements/${id}/pdf`);
